export default __webpack_public_path__ + "static/media/BrandocVillageWestMap.9d33dbfc.jpg";